import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

import MultiBarVertical from "../../../Components/Charts/MultiBarVerticalChart.js";

const LeadSourcePipelineApi = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-sales-success-centre/sales_lead_pipeline",
      body
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching service adoption data:", error);
    throw error;
  }
};

const LeadSourcePipeline = () => {
  const { data, submitted } = useSelector((e) => e.filtersSalesSuccessCenter);

  const {
    data: LeadSourcePipelineData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["LeadSourceRetail", submitted],
    queryFn: () => LeadSourcePipelineApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  return (
    <div className="bg-white rounded-xl shadow p-2 relative h-full">
      <WaterMark />
      {isFetching ? (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      ) : isError ||
        !LeadSourcePipelineData ||
        LeadSourcePipelineData.length === 0 ? (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      ) : (
        <>
          <div className="pb-2 text-base font-semibold text-[#4c4c4c]">
            Lead Souce Pipeline
          </div>
          <MultiBarVertical data={LeadSourcePipelineData} />
        </>
      )}
    </div>
  );
};

export default LeadSourcePipeline;
